// extracted by mini-css-extract-plugin
var _1 = "styles_button__VfL8f";
var _2 = "styles_header__zb55B";
var _3 = "styles_headerTitle__0eKlS";
var _4 = "styles_orders__g2ph2";
var _5 = "styles_ordersList__l+8QC";
export { _1 as "button", _2 as "header", _3 as "headerTitle", _4 as "orders", _5 as "ordersList" }
